import React, { useEffect, useState } from 'react'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { locales } from '../../../config/i18n/i18nProvider'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../../actions/login.actions'
import { Typography } from '@mui/material'

const LocaleSelector = () => {
  const { t, i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)
  const [languageSelected, setLanguageSelected] = useState('es_ES')
  const locale = useSelector(({ login }) => login.locale)
  const dispatch = useDispatch()
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleChange = (leng) => {
    if (typeof leng.value === 'string') {
      i18n.changeLanguage(leng.value)
      setLanguageSelected(leng.value)
      dispatch(actions.local(leng.value))
      setAnchorEl(null)
    }
  }

  useEffect(() => {
    setLanguageSelected(locale)
    i18n.changeLanguage(locale)
  }, [])

  return (
    <>
      <img
        style={{ width: '1.4rem', cursor: 'pointer' }}
        onClick={handleClick}
        src={'/assets/' + languageSelected + '.png'}
      />
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          style: {
            width: '20ch',
          },
        }}>
        {locales.map((leng) => (
          <MenuItem key={leng.value} onClick={() => handleChange(leng)} selected={leng.value === languageSelected}>
            <img
              style={{
                width: '20px',
                cursor: 'pointer',
                marginRight: '0.4rem',
              }}
              onClick={handleClick}
              src={'/assets/' + leng.value + '.png'}
            />
            <Typography color="primary">{t(leng.desc)}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LocaleSelector
